import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { sendRequest } from '../api';
import { Button } from '@/components/ui/Button';
import { useUser } from '../providers/UserProvider';

const InstagramConnect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const { fetchUser } = useUser();

  useEffect(() => {
    const connectInstagram = async () => {
      // Check for error response from Instagram
      if (searchParams.get('error')) {
        setError(searchParams.get('error_description')?.replace(/\+/g, ' ') || 'Authorization was denied');
        return;
      }

      const code = searchParams.get('code');
      if (!code) {
        setError('No authorization code received from Instagram');
        return;
      }

      // Remove the #_ that Instagram appends to the code
      const cleanCode = code.replace(/#_$/, '');

      try {
        const response = await sendRequest('/auth/instagram/callback', 'POST', { code: cleanCode });

        if (response.error) {
          throw new Error(response.error || 'Failed to connect Instagram account');
        }

        // Fetch updated user data before navigating
        await fetchUser();
        
        navigate('/settings', { replace: true });
      } catch (err) {
        setError(err.message);
      }
    };

    connectInstagram();
  }, [searchParams, navigate, fetchUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">Connection Failed</h2>
          <p className="text-muted-foreground">{error}</p>
          <Button
            onClick={() => navigate('/accounts')}
            variant="default"
            className="mt-4"
          >
            Return Home
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin mx-auto text-foreground" />
        <p className="mt-4 text-muted-foreground">Connecting your Instagram account...</p>
      </div>
    </div>
  );
};

export default InstagramConnect; 